import { jsx } from "react/jsx-runtime";
import FilterListIcon from "@mui/icons-material/FilterList";
import { validateTidalLicense } from "../../base/index.js";
function FilterList(props) {
  return /* @__PURE__ */ jsx(
    FilterListIcon,
    {
      "data-testid": "FilterList",
      ...props,
      "data-tidal": "TidalIcon",
      "data-tidal-icon": "FilterList",
      "data-tidal-icon-meta": "common,navigation"
    }
  );
}
FilterList.tidalIconMeta = {
  categories: "common,navigation",
  name: "FilterList"
};
validateTidalLicense();
export {
  FilterList
};
//# sourceMappingURL=FilterList.js.map
